import shortid from "shortid";

import { materialAlbedo } from "../constants";

export const getHeight = (cellParams, cellId) => {
  if (cellParams && cellParams[cellId] && cellParams[cellId].height) {
    return cellParams[cellId].height;
  }

  return 0;
};

export const getMaterials = (cellParams, cellId) => {
  if (cellParams && cellParams[cellId] && cellParams[cellId].materials) {
    return cellParams[cellId].materials;
  }

  return {};
};

export const getSurfaceArea = (cellParams, cellId) => {
  if (cellParams && cellParams[cellId] && cellParams[cellId].area) {
    return cellParams[cellId].area;
  }

  return 0.0;
};

export const getSurfaceDirection = (cellParams, cellId) => {
  if (cellParams && cellParams[cellId] && cellParams[cellId].direction) {
    return cellParams[cellId].direction;
  }

  return 0.0;
};

export const getMaterialAlbedo = () => materialAlbedo;

export const getDirectMaterialAlbedo = (material) =>
  materialAlbedo.Direct[material];

export const getDiffuseMaterialAlbedo = (material) =>
  materialAlbedo.Diffuse[material];

export const getAllCellIds = (cellParams) =>
  Object.getOwnPropertyNames(cellParams);

export const makeIds = (lim) => {
  let ids = [];
  let i = 0;
  while (i < lim) {
    let newId = shortid.generate();
    ids.push(newId);
    i++;
  }
  return ids;
};

// Rounds a float 'num' down to 'N' decimal places.
export const roundToNDecimalPlaces = (num, N = 3) => {
  const p = Math.pow(10, N);
  return (Math.round((num + Number.EPSILON) * p) / p).toFixed(N);
};
